import { createContext, useContext } from 'react';

/**
 * 떠 있는 목록 · 달력 · 메뉴를 portal 로 붙일 곳. 기본은 `document.body`.
 * 겹쳐 뜨는 창(ModalLayer)은 자기 덮개 틀을 넣어 둔다 — 그 안에 붙어야 창(z-modal) 뒤로 숨지 않고,
 * 창 본문의 스크롤(`overflow`)에도 잘리지 않는다.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

/** portal 을 붙일 요소. 겹쳐 뜨는 창 안이면 그 창의 덮개 틀, 아니면 `document.body` */
export function usePortalContainer(): HTMLElement {
  return useContext(PortalContainerContext) ?? document.body;
}
